var map = {
	"./point_icon_01.svg": "70d1",
	"./point_icon_02.svg": "93f5",
	"./point_icon_03.svg": "9433",
	"./point_icon_04.svg": "60dc",
	"./point_icon_05.svg": "7e58",
	"./point_icon_06.svg": "6f1f",
	"./point_icon_07.svg": "ef05",
	"./point_icon_08.svg": "9f3f",
	"./point_icon_09.svg": "688b7",
	"./point_icon_10.svg": "7363",
	"./point_icon_11.svg": "5cda",
	"./point_icon_12.svg": "2c64"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2aaa";